import React from 'react';
import { Link } from 'react-router-dom';
import MarketingNav from '../components/layout/MarketingNav';

const Pricing = () => {
  return (
    <>
      <MarketingNav transparent={false} />
      <div className="min-h-screen bg-gradient-to-br from-bgPrimary via-bgSecondary to-bgPrimary pt-20">
        {/* Hero Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-textPrimary mb-4">
              Two Pathways, Transparent Pricing
            </h1>
            <p className="text-xl text-textSecondary max-w-3xl mx-auto">
              Clinical (therapist-prescribed) or Self-Guided (independent). Same three core practices. Optional faith integration included at no extra cost.
            </p>
            <p className="text-lg text-textMuted mt-4">
              All plans include: Full 365-day program • All four phases • Daily Mind, Move, Journal practices • Progress tracking • Optional Faith pillar
            </p>
          </div>

          {/* Individual Plans */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-center text-textPrimary mb-8">Individual Plans</h2>
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {/* Foundation Tier */}
              <div className="bg-surface rounded-2xl shadow-lg p-8 border-2 border-border hover:border-primary transition-all">
                <h3 className="text-2xl font-bold text-textPrimary mb-2">Foundation</h3>
                <p className="text-textSecondary mb-6">Self-Guided pathway - Independent practice</p>
                
                <div className="mb-6">
                  <div className="flex items-baseline mb-2">
                    <span className="text-4xl font-bold text-textPrimary">$199</span>
                    <span className="text-textSecondary ml-2">/year</span>
                  </div>
                  <p className="text-sm text-textMuted">$0.55 per day • Save 43% vs monthly</p>
                  <div className="mt-4 flex items-baseline">
                    <span className="text-2xl font-bold text-textSecondary">$29</span>
                    <span className="text-textSecondary ml-2">/month</span>
                  </div>
                  <p className="text-sm text-textMuted">$0.97 per day</p>
                </div>

                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">Full 365-day mental wellness companion program</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">All four phases (Stabilize through Sustain)</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">Daily Mind, Move, Journal pillars</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">Encrypted journaling with mood tracking</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">Optional Faith pillar (enable anytime)</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-textSecondary">Progress dashboard & data export</span>
                  </li>
                </ul>

                <Link 
                  to="/register"
                  className="block w-full bg-cta text-white text-center py-3 rounded-lg font-semibold hover:bg-ctaHover transition-colors"
                >
                  Create Free Account
                </Link>
                <p className="text-sm text-textMuted text-center mt-3">Free access while the platform is publicly available.</p>
              </div>

              {/* Guided Tier */}
              <div className="bg-gradient-to-br from-primary to-support rounded-2xl shadow-xl p-8 text-white relative">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-cta text-white px-4 py-1 rounded-full text-sm font-bold">
                  Best Value
                </div>
                <h3 className="text-2xl font-bold mb-2">Guided</h3>
                <p className="text-textSecondary mb-6">Clinical pathway - Therapist-prescribed</p>
                
                <div className="mb-6">
                  <div className="flex items-baseline mb-2">
                    <span className="text-4xl font-bold">$149</span>
                    <span className="text-textSecondary ml-2">/year</span>
                  </div>
                  <p className="text-sm text-textSecondary">$0.41 per day • 25% less than Foundation</p>
                  <div className="mt-4 flex items-baseline">
                    <span className="text-2xl font-bold">$19</span>
                    <span className="text-textSecondary ml-2">/month</span>
                  </div>
                  <p className="text-sm text-textSecondary">$0.63 per day • 34% less than Foundation</p>
                </div>

                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-white mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="font-semibold">Everything in Foundation, plus:</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-white mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Clinician-client linkage in platform</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-white mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Consent-gated data sharing with clinician</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-white mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Encouragement messages from therapist</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-white mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Enhanced accountability partnership</span>
                  </li>
                </ul>

                <Link 
                  to="/register"
                  className="block w-full bg-surface text-primary text-center py-3 rounded-lg font-semibold hover:bg-bgSecondary transition-colors"
                >
                  Create Free Account
                </Link>
                <p className="text-sm text-textSecondary text-center mt-3">Ask your clinician for a referral code</p>
              </div>
            </div>
          </div>

          {/* Wellness Access Rate */}
          <div className="mb-16 max-w-4xl mx-auto">
            <div className="bg-surface border-2 border-success/40 rounded-2xl p-8">
              <div className="flex items-start">
                <svg className="w-8 h-8 text-green-600 mr-4 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-textPrimary mb-2">Financial Accessibility</h3>
                  <p className="text-textSecondary mb-4">
                    <strong>Wellness Access Rate:</strong> If the standard price is a barrier, we offer reduced rates starting at <strong>$89/year</strong> or <strong>$7.99/month</strong>. 
                    Self-certified, no documentation required. Every plan includes full program access—your mental wellness support doesn't have a price tier.
                  </p>
                  <p className="text-textSecondary">
                    <strong>Milestone Credits:</strong> Earn account credits when you hit program milestones (30, 60, 90, 180, 365 days). Up to $70 in credits possible.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Clinician Plans */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-center text-textPrimary mb-8">For Clinicians</h2>
            <div className="max-w-4xl mx-auto bg-surface rounded-2xl shadow-lg p-8 border-2 border-border">
              <h3 className="text-2xl font-bold text-textPrimary mb-4">Practice License</h3>
              <p className="text-textSecondary mb-6">
                Prescribe Momentum to your clients and monitor their engagement through your dashboard
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="border-2 border-border rounded-lg p-6">
                  <h4 className="text-lg font-bold text-textPrimary mb-2">Up to 5 Clients</h4>
                  <div className="flex items-baseline mb-4">
                    <span className="text-4xl font-bold text-success">Free</span>
                  </div>
                  <ul className="space-y-2 text-sm text-textSecondary">
                    <li>• Full clinician dashboard</li>
                    <li>• Client engagement analytics</li>
                    <li>• Unlimited referral codes</li>
                    <li>• Priority support</li>
                  </ul>
                </div>

                <div className="border-2 border-primary rounded-lg p-6 bg-bgSecondary">
                  <h4 className="text-lg font-bold text-textPrimary mb-2">Unlimited Clients</h4>
                  <div className="flex items-baseline mb-1">
                    <span className="text-4xl font-bold text-primary">$49</span>
                    <span className="text-textSecondary ml-2">/month</span>
                  </div>
                  <p className="text-sm text-textSecondary mb-4">$2.45 per client at 20 active users</p>
                  <ul className="space-y-2 text-sm text-textSecondary">
                    <li>• Everything in Free tier</li>
                    <li>• Unlimited active clients</li>
                    <li>• Sponsored seat purchasing</li>
                    <li>• Advanced reporting</li>
                  </ul>
                </div>
              </div>

              <Link 
                to="/register?role=clinician"
                className="block w-full bg-cta text-white text-center py-3 rounded-lg font-semibold hover:bg-ctaHover transition-colors"
              >
                Create Clinician Account
              </Link>
            </div>
          </div>

          {/* Enterprise */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-center text-textPrimary mb-8">For Organizations</h2>
            <div className="max-w-5xl mx-auto bg-gradient-to-br from-bgPrimary to-bgSecondary rounded-2xl shadow-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Enterprise License</h3>
              <p className="text-textSecondary mb-6">
                Treatment centers, hospitals, group practices, mental wellness companion programs, and institutions serving mental wellness populations at scale
              </p>

              <div className="grid md:grid-cols-4 gap-4 mb-8">
                <div className="bg-surface rounded-lg p-4">
                  <div className="text-3xl font-bold text-primary">$129</div>
                  <div className="text-sm text-textMuted">per user/year</div>
                  <div className="text-xs text-textMuted mt-1">10–49 users</div>
                </div>
                <div className="bg-surface rounded-lg p-4">
                  <div className="text-3xl font-bold text-primary">$99</div>
                  <div className="text-sm text-textMuted">per user/year</div>
                  <div className="text-xs text-textMuted mt-1">50–149 users</div>
                </div>
                <div className="bg-surface rounded-lg p-4">
                  <div className="text-3xl font-bold text-primary">$79</div>
                  <div className="text-sm text-textMuted">per user/year</div>
                  <div className="text-xs text-textMuted mt-1">150–499 users</div>
                </div>
                <div className="bg-surface rounded-lg p-4">
                  <div className="text-3xl font-bold text-primary">Custom</div>
                  <div className="text-sm text-textMuted">pricing</div>
                  <div className="text-xs text-textMuted mt-1">500+ users</div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div>
                  <h4 className="font-semibold mb-3">Includes:</h4>
                  <ul className="space-y-2 text-sm text-textSecondary">
                    <li>• Administrative portal for bulk enrollment</li>
                    <li>• Aggregate outcome reporting</li>
                    <li>• Grant compliance formatting</li>
                    <li>• Dedicated onboarding support</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold mb-3">Additional Options:</h4>
                  <ul className="space-y-2 text-sm text-textSecondary">
                    <li>• Custom branding (250+ users)</li>
                    <li>• API/EHR integration (500+ users)</li>
                    <li>• Grant-funded program pricing</li>
                    <li>• Organization vouchers for partners</li>
                  </ul>
                </div>
              </div>

              <a 
                href="mailto:enterprise@mhdfmomentum.com"
                className="block w-full bg-cta text-white text-center py-3 rounded-lg font-semibold hover:bg-ctaHover transition-colors"
              >
                Contact Enterprise Sales
              </a>
            </div>
          </div>

          {/* FAQ */}
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-textPrimary mb-8">Frequently Asked Questions</h2>
            <div className="space-y-6">
              <div className="bg-surface rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-bold text-textPrimary mb-2">Is the platform currently free?</h3>
                <p className="text-textSecondary">
                  Yes. The platform is currently free to use, so there is no trial period or payment required to begin.
                </p>
              </div>
              <div className="bg-surface rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-bold text-textPrimary mb-2">Are all features available in every plan?</h3>
                <p className="text-textSecondary">
                  Absolutely. Every plan delivers the same clinical experience. The pricing tiers reflect differences in distribution channel 
                  and support infrastructure—not differences in mental wellness companion content.
                </p>
              </div>
              <div className="bg-surface rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-bold text-textPrimary mb-2">How do I get the Guided tier discount?</h3>
                <p className="text-textSecondary">
                  Ask your therapist or counselor for a referral code during registration. The 25% discount will be automatically applied.
                </p>
              </div>
              <div className="bg-surface rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-bold text-textPrimary mb-2">Can I cancel anytime?</h3>
                <p className="text-textSecondary">
                  Yes. You can cancel your subscription at any time. Your access continues until the end of your billing period.
                </p>
              </div>
              <div className="bg-surface rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-bold text-textPrimary mb-2">What payment methods do you accept?</h3>
                <p className="text-textSecondary">
                  We accept all major credit cards, debit cards, and digital wallets. Enterprise customers can arrange for invoicing.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-textPrimary mb-4">Ready to Begin Your Mental Wellness Journey?</h2>
            <p className="text-xl text-textSecondary mb-8">Create a free account and start your daily practice today.</p>
            <Link 
              to="/register"
              className="inline-block bg-cta text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-ctaHover transition-colors"
            >
              Create Free Account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
